// extracted by mini-css-extract-plugin
export var actions = "StockTakesInProgressModal-module--actions--UEJtC";
export var cancelButton = "StockTakesInProgressModal-module--cancelButton--oFd9C";
export var content = "StockTakesInProgressModal-module--content--QPqLi";
export var footer = "StockTakesInProgressModal-module--footer--pEWSL";
export var header = "StockTakesInProgressModal-module--header--ZlnqU";
export var iconWrapper = "StockTakesInProgressModal-module--iconWrapper--vdfqy";
export var noOrders = "StockTakesInProgressModal-module--noOrders--xM3bJ";
export var thumbnail = "StockTakesInProgressModal-module--thumbnail--+xlnE";
export var thumbnailWrapper = "StockTakesInProgressModal-module--thumbnailWrapper--ln-I0";